import React, { useEffect, useState } from "react";
import { heading } from "../../utils/helperData";
import { HiDotsVertical } from "react-icons/hi";
import { IoIosSearch } from "react-icons/io";
import { CgAddR } from "react-icons/cg";
import Pagination from "../../customComponent/Pagination";
import { useNavigate } from "react-router-dom";
import {
  ADD_INSPECTOR,
  EDIT_INSPECTOR_DETAILS,
  VIEW_INSPECTOR_DETAILS,
} from "../../utils/RouteConstant";
import {
  Box,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import Danger from "../../../asesst/Danger.svg";
import { RxCrossCircled } from "react-icons/rx";
import { BsPersonExclamation } from "react-icons/bs";
import Eye from "../../../asesst/Eye.svg";
import Vector from "../../../asesst/Vector.svg";
import Shield_Cross from "../../../asesst/Shield_Cross.svg";
import {
  BlockInspectors,
  EditInspectorsPassword,
  fetchInspectors,
} from "../../../redux/action/InspectorManagement/AddInspectorAction";
import { useDispatch, useSelector } from "react-redux";
import { TbPasswordUser } from "react-icons/tb";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IoMdArrowDropup, IoMdArrowDropdown } from "react-icons/io";

const ManageInspector = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const itemsPerPage = 10;
     const [rowsPerPage, setRowsPerPage] = useState(10);
     const rowsPerPageOptions = [10, 20, 50, 100, "All"];
  const [currentPage, setCurrentPage] = useState(1);
  const [openDangerModal, setOpenDangerModal] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedInspectorId, setSelectedInspectorId] = useState(null);
  const [blockInspectorId, setBlockInspectorId] = useState(null);
  const [selectedInspector, setSelectedInspector] = useState(null);
  const [sortOption, setSortOption] = useState("");

  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [sortField, setSortField] = useState("updatedAt");
  const [sortOrder, setSortOrder] = useState("DESC");

  const { inspectorData, totalCount } = useSelector((state) => state.inspector);
  console.log("userdata", inspectorData);

  useEffect(() => {
    dispatch(
      fetchInspectors(
        currentPage,
        searchTerm,
        rowsPerPage,
        sortField,
        sortOrder
      )
    );
  }, [dispatch, currentPage, searchTerm, sortField, sortOrder, rowsPerPage]);

  // const totalPages = Math.ceil(totalCount / itemsPerPage);

        const totalPages =
          rowsPerPage === "All" ? 1 : Math.ceil(totalCount / rowsPerPage);

        const handleRowsPerPageChange = (event) => {
          const value = event.target.value;
          if (value === "All") {
            setRowsPerPage(totalCount);
            setCurrentPage(1);
          } else {
            setRowsPerPage(Number(value));
            setCurrentPage(1);
          }
        };

  const handleOpenDangerModal = (blockInspectorId) => {
    setBlockInspectorId(blockInspectorId);
    setOpenDangerModal(true);
    handleCloseUserMenu();
  };

  const handleCloseDangerModal = () => {
    setOpenDangerModal(false);
    setBlockInspectorId(null);
  };

  const handleAddInspector = () => {
    navigate(ADD_INSPECTOR);
  };

  const handleOpenUserMenu = (event, inspectorId) => {
    setAnchorElUser(event.currentTarget);
    setSelectedInspectorId(inspectorId);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
    setSelectedInspectorId(null);
  };

  const handleViewDetails = (inspectorId) => {
    console.log("Navigating to details for inspector:", inspectorId);
    navigate(`${VIEW_INSPECTOR_DETAILS}/${inspectorId}`);
    handleCloseUserMenu();
  };

  const handleEditDetails = (inspectorId) => {
    navigate(`${EDIT_INSPECTOR_DETAILS}/${inspectorId}`);
    handleCloseUserMenu();
  };
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleBlockInspector = () => {
    if (selectedInspector) {
      const newStatus = selectedInspector.user_status !== "ACTIVE";
      dispatch(BlockInspectors(selectedInspector._id, newStatus)).then(() => {
        dispatch(fetchInspectors(currentPage, searchTerm, rowsPerPage));
        handleCloseDangerModal();
      });
    } else {
      console.error("No inspector selected for blocking/unblocking");
    }
  };

  const handleOpenChangePasswordModal = () => {
    setOpenChangePasswordModal(true);
    handleCloseUserMenu();
  };

  const handleCloseChangePasswordModal = () => {
    setOpenChangePasswordModal(false);
    setNewPassword("");
    setConfirmPassword("");
    setPasswordError("");
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const handlePasswordChange = async () => {
    setPasswordError("");
    if (newPassword.length < 8) {
      setPasswordError("Password must be at least 8 characters long.");
      return;
    }
    if (newPassword.length > 20) {
      setPasswordError("Password must be no more than 20 characters long.");
      return;
    }
    if (!/[A-Z]/.test(newPassword)) {
      setPasswordError("Password must contain at least one uppercase letter.");
      return;
    }
    if (!/[a-z]/.test(newPassword)) {
      setPasswordError("Password must contain at least one lowercase letter.");
      return;
    }
    if (!/[0-9]/.test(newPassword)) {
      setPasswordError("Password must contain at least one digit.");
      return;
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) {
      setPasswordError("Password must contain at least one special character.");
      return;
    }
    if (/\s/.test(newPassword)) {
      setPasswordError("Password must not contain spaces.");
      return;
    }
    const commonPasswords = ["password", "12345678"];
    if (commonPasswords.includes(newPassword.toLowerCase())) {
      setPasswordError(
        "Password is too common. Please choose a different password."
      );
      return;
    }
    if (/^(.)\1{2,}$/.test(newPassword)) {
      setPasswordError(
        "Password must not contain three or more consecutive identical characters."
      );
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError("Passwords do not match.");
      return;
    }
    setPasswordError("");
    try {
      const response = await dispatch(
        EditInspectorsPassword(selectedInspector._id, newPassword)
      );
      if (response.success) {
        dispatch(fetchInspectors(currentPage, searchTerm, rowsPerPage));
        handleCloseChangePasswordModal();
      } else {
        setPasswordError("Failed to change password.");
      }
    } catch (error) {
      setPasswordError("An unexpected error occurred. Please try again.");
    }
  };

  const backendSortableFields = [
    "createdAt",
    "inspector_name",
    // "mobile_number",
    // "email",
    "user_type",
    "employee_id",
    "user_status",
    "updatedAt"
  ];

  const sortedData = () => {
    if (!inspectorData?.data) return [];
    if (
      sortField !== "updatedAt" &&
      backendSortableFields.includes(sortField)
    ) {
      return inspectorData.data;
    }

    const sorted = [...inspectorData.data];

    switch (sortOption || sortField) {
      case "updatedAt":
        return sorted.sort((a, b) => {
          const dateA = new Date(a.last_modified);
          const dateB = new Date(b.last_modified);
          return sortOrder === "ASC" ? dateA - dateB : dateB - dateA;
        });

      case "inspector_name":
      case "employee_id":
      case "user_status":
      default:
        return sorted;
    }
  };

  const handleSort = (field) => {
    if (!field) return;
    if (sortField === field) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      setSortField(field);
      setSortOrder("ASC");
    }
    setCurrentPage(1);
  };

  const SortIndicator = ({ field }) => {
    if (sortField !== field) {
      return (
        <div className="inline-flex flex-col ml-2">
          <IoMdArrowDropup className="text-gray-300" />
          <IoMdArrowDropdown className="text-gray-300 -mt-2" />
        </div>
      );
    }
    return (
      <span className="ml-2">
        {sortOrder === "ASC" ? (
          <IoMdArrowDropup className="text-gray-600" />
        ) : (
          <IoMdArrowDropdown className="text-gray-600" />
        )}
      </span>
    );
  };

  return (
    <div>
      <h1 className="text-3xl text-[#202224]  sm:text-3xl font-bold mb-6">
        User Management
      </h1>
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 space-y-4 sm:space-y-0 sm:space-x-4">
        <div className="relative w-full sm:w-64 flex-grow sm:flex-grow-0">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={handleSearch}
            className="w-full lg:w-[400px] pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
        <button
          onClick={handleAddInspector}
          className="w-full sm:w-auto bg-[#1C3664] text-white px-4 py-2 rounded-lg flex items-center justify-center hover:bg-blue-900 transition-colors"
        >
          <CgAddR className="mr-2" />
          Add New Inspector/User
        </button>
      </div>
      <div className="bg-white rounded-2xl shadow-sm p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row justify-between items-center mb-6 space-y-4 sm:space-y-0 sm:space-x-4">
          <div className="relative w-full sm:w-74 flex-grow sm:flex-grow-0">
            <span className="font-semibbold text-2xl">
              Inspector / Guest User Details
            </span>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-[#F1F4F9]">
              <tr>
                {heading.map((head, index) => (
                  <th
                    key={index}
                    scope="col"
                    className={`px-4 py-2 text-left text-base font-medium text-[#202224] uppercase tracking-wider ${
                      head.sortable
                        ? "cursor-pointer hover:bg-gray-100 transition-colors duration-200"
                        : ""
                    }`}
                    onClick={() => head.sortable && handleSort(head.field)}
                  >
                    <div className="flex items-center justify-between">
                      <span>{head.name}</span>
                      {head.sortable && <SortIndicator field={head.field} />}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {/* {isLoading && (
                <div className="flex items-center justify-center p-6 w-full">
                  <div className="flex items-center space-x-2">
                    <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                    <span className="text-xl font-semibold text-gray-700">
                      Loading...
                    </span>
                  </div>
                </div>
              )}
              {error && <div>Error: {error}</div>} */}
              {sortedData().length > 0 ? (
                <>
                  {sortedData().map((inspector, index) => (
                    <tr key={inspector?._id}>
                      <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                        {(currentPage - 1) * rowsPerPage + index + 1}
                      </td>
                      <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                        {inspector.employee_id || "-"}
                      </td>
                      <td className="px-6 py-2 whitespace-nowrap text-sm  text-gray-500">
                        {inspector.inspector_name || "-"}
                      </td>
                      <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                        {inspector.user_type === 2
                          ? "User"
                          : inspector.user_type === 3
                          ? "Inspector"
                          : "-"}
                      </td>

                      <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                        {inspector.mobile_number || "-"}
                      </td>
                      <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                        {inspector.email || "-"}
                      </td>
                      <td className="px-6 py-2 whitespace-nowrap">
                        <span
                          className={`px-4 py-1 inline-flex text-xs leading-5 font-base rounded-full ${
                            inspector.user_status === "ACTIVE"
                              ? "bg-[#0AA43D] text-[#FFFFFF]"
                              : "bg-[#FFB3B3] text-[#FFFFFF]"
                          }`}
                        >
                          {inspector.user_status || "-"}
                        </span>
                      </td>
                      <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                        {/* {inspector.last_modified} */}
                        {inspector?.last_modified
                          ? (function () {
                              const parts = inspector?.last_modified.split("-");
                              const formattedDate = new Date(
                                `${parts[1]}/${parts[0]}/${parts[2]}`
                              );
                              return formattedDate.toLocaleDateString("en-US", {
                                month: "2-digit",
                                day: "2-digit",
                                year: "numeric",
                              });
                            })()
                          : "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                          onClick={(e) => handleOpenUserMenu(e, inspector._id)}
                          className="text-gray-400 hover:text-gray-500"
                        >
                          <HiDotsVertical />
                        </button>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan="8" className="px-6 py-4 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <img
                        src="https://img.freepik.com/premium-vector/no-data-concept-illustration_86047-488.jpg?semt=ais_hybrid"
                        alt="No Data"
                        className="mb-4 w-[200px] h-[200px]"
                      />
                      <p className="text-lg text-gray-500">
                        No Inspector created.
                      </p>
                      <p className="text-sm text-gray-400">
                        Please check back later or created new inspector.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <Menu
            id="menu-appbar"
            sx={{ mt: "22px" }}
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <div className="flex flex-col">
              <MenuItem>
                <span
                  onClick={() => handleViewDetails(selectedInspectorId)}
                  className="text-[#1C3664] text-base font-poppins flex items-center"
                >
                  <img src={Eye} alt="view details" className="mr-2" />
                  View Details
                </span>
              </MenuItem>
              <MenuItem>
                <span
                  onClick={() => handleEditDetails(selectedInspectorId)}
                  className="text-[#1C3664] text-base font-poppins flex items-center"
                >
                  <img src={Vector} alt="edit details" className="mr-2" />
                  Edit Details
                </span>
              </MenuItem>
              <MenuItem>
                <span
                  onClick={() => {
                    const selectedInspectorData = inspectorData?.data?.find(
                      (inspector) => inspector._id === selectedInspectorId
                    );
                    setSelectedInspector(selectedInspectorData);
                    handleOpenChangePasswordModal(selectedInspectorData);
                  }}
                  className="text-[#1C3664] text-base font-poppins flex items-center"
                >
                  <TbPasswordUser alt="edit details" className="mr-2" />
                  Change Password
                </span>
              </MenuItem>
              <MenuItem>
                <span
                  onClick={() => {
                    const selectedInspectorData = inspectorData?.data?.find(
                      (inspector) => inspector._id === selectedInspectorId
                    );
                    console.log("selectedInspectorData", selectedInspectorData);
                    setSelectedInspector(selectedInspectorData);
                    handleOpenDangerModal(selectedInspectorData);
                  }}
                  className="text-[#F93C65] text-base font-poppins flex items-center"
                >
                  <img src={Shield_Cross} alt="blocked" className="mr-2" />
                  {inspectorData?.data?.find(
                    (inspector) => inspector._id === selectedInspectorId
                  )?.user_status === "ACTIVE"
                    ? "Block"
                    : "Unblock"}
                </span>
              </MenuItem>
            </div>
          </Menu>

          {/* ................ Change password modal ..................... */}

          <Modal open={openChangePasswordModal}>
            <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
              <h2 className="text-2xl mb-4">
                Change Password for {selectedInspector?.inspector_name}
              </h2>
              <TextField
                label="New Password"
                type={showPassword ? "text" : "password"}
                fullWidth
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                margin="normal"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleTogglePasswordVisibility}>
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                margin="normal"
                error={passwordError !== ""}
                helperText={passwordError}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleToggleConfirmPasswordVisibility}
                      >
                        {showConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {/* {passwordError && (
                <p className="text-red-500 text-sm mt-2">{passwordError}</p>
              )} */}
              <div className="mt-6 flex justify-center gap-4">
                <button
                  onClick={handleCloseChangePasswordModal}
                  className="bg-[#FFFFFF] border w-full px-4 py-2 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  onClick={handlePasswordChange}
                  className="bg-[#1C3664] border w-full text-white px-4 py-2 rounded-lg"
                >
                  Change Password
                </button>
              </div>
            </Box>
          </Modal>

          {/* .................. Block Unblock modal ..................... */}

          <Modal
            open={openDangerModal}
            className="justiify-center items-center "
          >
            <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
              <RxCrossCircled
                onClick={handleCloseDangerModal}
                className="float-end top-2 h-6 w-6 cursor-pointer"
              />
              <div className="text-center inline-flex mt-8">
                <div className=" flex items-center justify-center">
                  <img src={Danger} alt="Success" className="w-full h-full " />
                </div>
              </div>
              <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
                {selectedInspector?.user_status === "ACTIVE"
                  ? "Block"
                  : "Unblock"}{" "}
                Inspector
              </p>
              <div className="flex items-center justify-center mb-2">
                <span>
                  <BsPersonExclamation className="h-5 w-5" />
                </span>
                <span className="text-[#1C3664] text-lg mt-1 font-poppins">
                  &nbsp;&nbsp;{selectedInspector?.inspector_name}
                </span>
              </div>
              <span className="text-[#6D6D6D]">
                Are you sure you want to{" "}
                {selectedInspector?.user_status === "ACTIVE"
                  ? "block"
                  : "unblock"}{" "}
                this inspector account?
              </span>
              <div className="mt-6 flex justify-center gap-4">
                <button
                  onClick={() => handleBlockInspector(blockInspectorId)}
                  className="bg-[#FFFFFF] border w-[70px] px-4 py-2 rounded-lg"
                >
                  Yes
                </button>
                <button
                  onClick={handleCloseDangerModal}
                  className="bg-[#1C3664] border w-[70px] text-white px-4 py-2 rounded-lg"
                >
                  No
                </button>
              </div>
            </Box>
          </Modal>
        </div>
      </div>

      <div className="flex items-center justify-end mb-4 space-x-3">
        <div className="flex items-center mt-6 ">
          <label htmlFor="rows-per-page" className="mr-2">
            Rows per page:
          </label>
          <select
            id="rows-per-page"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="border border-solid border-2 h-[34px] rounded p-1 text-gray-500"
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {totalPages > 1 && rowsPerPage !== "All" && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        )}
      </div>
      {/* {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )} */}
    </div>
  );
};

export default ManageInspector;
